<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="g-common-top-header">
        <!-- <div>
          <el-breadcrumb separator="|" style="padding-left: 5px; line-height: 35px;">
            <template v-if="$route.path.endsWith('/exam/edit')">
              <el-breadcrumb-item><a href="javascript:void(0)" style="font-weight:bold;">试卷设计</a></el-breadcrumb-item>
              <el-breadcrumb-item><a href="javascript:void(0)" style="font-weight:bold; color: blue" @click="toExamSetting">考试设置</a></el-breadcrumb-item>
            </template>
            <template v-else>
              <el-breadcrumb-item><a href="javascript:void(0)" style="font-weight:bold;">试卷设计</a></el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div> -->
        <div v-if="$route.path.endsWith('/exam/edit')" class="g-tab-ctn">
          <div @click="switchTab(key)" v-for="(item, key) in constant.tabs" :class="item.class01" :key="key">
            <span :class="item.class02">{{ item.text }}</span>
          </div>
        </div>
        <div v-else class="g-tab-ctn">
          <div @click="switchTab(key, 'init')" v-for="(item, key) in constant.tabs01" :class="item.class01" :key="key">
            <span :class="item.class02">{{ item.text }}</span>
          </div>
        </div>
        <div style="margin-left: auto;">
          <el-button type="primary" @click="submitForm">保存</el-button>
          <el-button type="primary" @click="submitFormAndBack">保存&返回列表</el-button>
        </div>
      </div>

      <el-container class="g-common-ctn" style="border-top-left-radius: 0; padding: 0;">
        <el-aside style="width: 150px; border-right:1px solid #e6e6e6">
          <div class="dtTxContent">
            <div style="font-size: 16px; padding: 10px; text-align: center;">题目类型</div>
            <div class="dtTxBtn" @click="addDt('1', '单选题')"><img alt="单选题" class="customIcon" src="../../assets/icon/radio.png"/>单选题</div>
            <div class="dtTxBtn" @click="addDt('2', '多选题')"><img alt="多选题" class="customIcon" src="../../assets/icon/checkbox.png"/>多选题</div>
            <div class="dtTxBtn" @click="addDt('3', '填空题')"><i class="el-icon-edit"/>填空题</div>
            <div class="dtTxBtn" @click="addDt('4', '判断题')"><img alt="判断题" class="customIcon" src="../../assets/icon/select.png"/>判断题</div>
            <div class="dtTxBtn" @click="addDt('5', '问答题')"><img alt="问答题" class="customIcon" src="../../assets/icon/paragraph.png"/>问答题</div>
            <div class="dtTxBtn" @click="addDt('6', '录音题')"><img alt="录音题" class="customIcon" src="../../assets/icon/record.png"/>录音题</div>
          </div>
        </el-aside>
        <el-container>
          <el-header style="height: 40px; display: flex; align-items: center;
          box-shadow: 0 3px 10px hsla(0,0%,40%,.05);
          padding: 0 20px !important;">
            <strong>{{ this.$route.query.sjmc }}</strong>
            <div style="width: 20px;"></div>
            <span>
              总分:&nbsp;<span style="color: #508ff6;font-weight: 600;">{{sjk.sjzf}}</span>分
            </span>
          </el-header>
          <el-main style="padding: 20px !important;">
            <!-- style="background-color: #f3f5f6; margin-top: 40px; padding-bottom: 40px;" -->
            <div v-for="(ksySjkDt, dtIdx) in sjk.ksySjkDtList" :key="dtIdx" :id="'dt' + dtIdx" class="dtDiv">
              <el-row class="dtHandle handle">
                <span title="上移" @click="up(sjk.ksySjkDtList, dtIdx)"><i class="el-icon-top"></i></span>
                <span title="下移" @click="down(sjk.ksySjkDtList, dtIdx)"><i class="el-icon-bottom"></i></span>
                <span style="color: red;" title="删除" @click="remove(sjk.ksySjkDtList, dtIdx)"><i class="el-icon-delete-solid"></i></span>
              </el-row>
              <el-row style="margin-bottom: 5px; padding-top: 5px">
                <el-col :span="7"><el-input v-model="ksySjkDt.dtmc" style="width: 150px" placeholder="请输入大题说明" />『{{txms[ksySjkDt.tx]}}』</el-col>
                <el-col :span="7">
                  <span style="padding-top: 5px">每题</span>
                  <el-input-number :style="`width: 65px;margin:0 3px; ${ ksySjkDt.visibleFlag ? 'opacity:0.3' :'' }`" placeholder="题目分数" v-model="ksySjkDt.mxtfz" :precision="1" :controls="false" @change="countAll()"/>
                  <!-- <el-input-number style="width: 90px" placeholder="题目分数" v-model="ksySjkDt.mxtfz" :precision="1" :controls="false" @change="countAll"/> -->
                  <!--
                  <el-input v-model.number="ksySjkDt.mxtfz" placeholder="题目分数" style="width: 90px" type="number" onkeyup="value = value.replace(/^(0+)|[^\d]+/g,'')" @change="countAll"/>
                  -->
                  <span style="padding-top: 5px">分&nbsp;&nbsp;&nbsp;共<span style="font-weight: bold;">{{ksySjkDt.stgs}}</span>题，共<span style="font-weight: bold;">{{ksySjkDt.dtzf}}</span>分</span>
                </el-col>
                <el-col :span="8">
                  <el-checkbox style="margin-right: 0" v-model="ksySjkDt.stlx" true-label="1" false-label="0" border>试题乱序</el-checkbox>
                  <el-checkbox style="margin-right: 0" v-if="ksySjkDt.tx === '1' || ksySjkDt.tx === '2'" v-model="ksySjkDt.xxlx" true-label="1" false-label="0" border>选项乱序</el-checkbox>
                  <el-checkbox style="margin-right: 0" v-if="ksySjkDt.tx === '2'" v-model="ksySjkDt.lxdf" true-label="1" false-label="0" border>漏选得分</el-checkbox>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 5px; text-align: center">
                <el-button v-if="sjk.zjfs === '1'" @click="addSt(ksySjkDt)"><i class="el-icon-plus">&emsp;添加试题</i></el-button>
                <el-button v-if="sjk.zjfs === '2' || sjk.zjfs === '3'" type="primary" @click="setCtgz(ksySjkDt)">设置选题规则</el-button>
              </el-row>
              <el-row style="display: inline-flex; margin-bottom: 5px; text-align: left" v-if="(sjk.zjfs === '2' || sjk.zjfs === '3') && ksySjkDt.ksySjkCtgzList && ksySjkDt.ksySjkCtgzList.length > 0" >
                  <div style="display: inline-block; min-width: 100px; max-width: 600px; margin-right: 10px" :id="ksySjkDt.dtid + '_flTag'"></div>
                  <div style="display: inline-block">
                    <div style="display: inline-block" v-for="(ctgz, index) in ksySjkDt.ksySjkCtgzList" :key="index">
                      <template v-if="index === 0">
                        题目难度（
                      </template>
                      {{index === 0 ? '' : '，'}}{{nycdms[ctgz.nycd]}}：<span style="font-size: 16px; color: blue">{{ctgz.ctgs}}</span>个
                      <template v-if="index === ksySjkDt.ksySjkCtgzList.length - 1">
                        )
                      </template>
                    </div>
                  </div>
              </el-row>
              <div v-for="(ksySjkSt, stIdx) in ksySjkDt.ksySjkStList" :key="stIdx">
                <template v-if="ksySjkSt.tx !== '9'">
                  <div class="stDiv">
                    <el-row class="stHandle handle" style="align-items: center;">
                      <span style="margin:0;">分值:</span>
                      <el-input-number size="mini" style="margin:0 3px; width: 50px;" v-model="ksySjkSt.stfz" :controls="false"  @change="initVisFlag(ksySjkDt, ksySjkSt)"/>
                      <span style="margin:0;">分</span>
                      <span title="上移" @click="up(ksySjkDt.ksySjkStList, stIdx)"><i class="el-icon-top"></i></span>
                      <span title="下移" @click="down(ksySjkDt.ksySjkStList, stIdx)"><i class="el-icon-bottom"></i></span>
                      <span style="color: red;" title="删除" @click="remove(ksySjkDt.ksySjkStList, stIdx)"><i class="el-icon-delete-solid"></i></span>
                      <span title="设置" @click="showSet(ksySjkSt)"><i class="el-icon-s-tools"></i></span>
                    </el-row>
                    <!-- 题干 -->
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 10px; margin-right: 10px; padding-top: 3px;">{{stIdx+1}}. </el-col>
                      <el-col style="width: calc(100% - 320px)">
                        <pre class="editorHtml" v-html="ksySjkSt.stnr || ksySjkSt.tg"></pre>
                      </el-col>
                    </el-row>
                    <!-- 单选题 -->
                    <el-row v-if="ksySjkSt.tx === '1'">
                      <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx"  style="margin-bottom: 15px; width: calc(100% - 320px)">
                        <el-radio onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px; display: inline;">
                          {{options[stxxIdx]}}.
                        </el-radio>
                        <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                      </div>
                    </el-row>
                    <!-- 多选题 -->
                    <el-row v-if="ksySjkSt.tx === '2'">
                      <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx" style="margin-bottom: 15px; width: calc(100% - 320px)">
                        <el-checkbox onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px; display: inline;">
                          {{options[stxxIdx]}}.
                        </el-checkbox>
                        <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                      </div>
                    </el-row>
                    <!-- 填空题 -->
                    <el-row v-if="ksySjkSt.tx === '3'">
                      <el-input v-for="(da, index) in ksySjkSt.ksySjkStda.ksda" :key="index" :placeholder="'请输入第'+(index + 1)+'个填空项'" style="width: 400px; padding: 5px; display: block"></el-input>
                    </el-row>
                    <!-- 判断题 -->
                    <el-row v-if="ksySjkSt.tx === '4'">
                      <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx"  style="margin-bottom: 15px; width: calc(100% - 320px)">
                        <el-radio onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px;">
                          {{options[stxxIdx]}}.
                        </el-radio>
                        <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                      </div>
                    </el-row>
                    <el-row v-if="ksySjkSt.tx === '1' || ksySjkSt.tx === '2'" style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col style="width: calc(100% - 400px)">{{parseABC(ksySjkSt.ksySjkStda.bzda, ksySjkSt.ksySjkStxxList)}}</el-col>
                    </el-row>
                    <el-row v-else-if="ksySjkSt.tx === '3'" style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col style="width: calc(100% - 400px)">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.bzda ? ksySjkSt.ksySjkStda.bzda.split('€').join('<br/>') : ''"></pre>
                      </el-col>
                    </el-row>
                    <el-row v-else-if="ksySjkSt.tx === '4'" style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col style="width: calc(100% - 400px)">{{parseXxsm(ksySjkSt.ksySjkStda.bzda, ksySjkSt.ksySjkStxxList)}}</el-col>
                    </el-row>
                    <el-row v-else style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col style="width: calc(100% - 400px)">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.bzda" ></pre>
                      </el-col>
                    </el-row>
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 80px">答案解析：</el-col>
                      <el-col style="width: calc(100% - 400px)">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.dajx || '<br/>'" ></pre>
                      </el-col>
                    </el-row>
                  </div>
                </template>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-main>
    <!-- <el-container style="position: fixed; top: 125px; width: 100%; height: 86%; background-color: #fafafa;">
    </el-container> -->
    <el-dialog title="试题编辑" :visible.sync="showStEdit" :modal-append-to-body='false' width="80%">
      <stEdit :stObj="stObj" :visible.sync="showStEdit" v-if="showStEdit" ></stEdit>
    </el-dialog>
    <el-dialog title="试题选择" v-if="showDtList" :visible.sync="showDtList" top="5vh"
      :modal-append-to-body='false' :show-close="false" width="1000px">
      <div slot="title">
        <span style="font-size: 16px; color: blue">{{txms[dtObj.tx]}}：</span>
        每题<span style="font-size: 16px; color: blue">{{dtObj.mxtfz}}</span>分，
        共<span style="font-size: 16px; color: blue">{{dtObj.stgs}}</span>道题，
        共<span style="font-size: 16px; color: blue">{{dtObj.dtzf}}</span>分
        <el-button style="float: right;" type="success" @click="selectAndClose()">选择并关闭</el-button>
      </div>
      <stList :dtObj="dtObj" :allDtData="allDtData" @countAll="countAll" style="padding: 0px"></stList>
    </el-dialog>
    <el-dialog title="抽取规则" :visible.sync="showCtgz" :modal-append-to-body='false' width="800px">
      <ctgz :visible.sync="showCtgz" :dtObj="dtObj" :allDtData="allDtData" :zjfs="sjk.zjfs" @countAll="countAll" @appendFlTag="appendFlTag"></ctgz>
    </el-dialog>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import { detail, save } from '@/api/examPaper'
import { getFlmcs } from '@/api/questions'
import stEdit from '@/views/examPaper/stEdit'
import stList from '@/views/examPaper/stList'
import ctgz from '@/views/examPaper/ctgz'
import constant from '../../assets/js/constant'
export default {
  data () {
    return {
      constant,
      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      nycdms: { 1: '简单', 2: '普通', 3: '困难' },
      showDtList: false,
      dtObj: {},
      showStEdit: false,
      stObj: {},
      showCtgz: false,

      sjk_init: null, // 上一个页面传入过来的试卷信息
      sjid_init: null, // 默认的试卷ID
      ksid_init: null, // 默认的考试ID
      txms: { 1: '单选题', 2: '多选题', 3: '填空题', 4: '判断题', 5: '问答题', 6: '录音题' },

      autoSave: false,

      sjk: {},
      sjkStr: JSON.stringify(this.sjk),
      allDtData: [] // 所有大题数据
    }
  },
  components: {
    myHeader,
    stEdit,
    stList,
    ctgz
  },
  methods: {
    appendFlTag (dtid, flbhs) {
      const params = { flbhs: flbhs }
      getFlmcs(params).then(res => {
        this.$http.callback(res, () => {
          document.getElementById(dtid + '_flTag').innerHTML = '选择试题分类：<span style="color: blue">' + res.data + '</spam>'
        })
      })
    },
    // 添加一个大题
    addDt (tx, txmc) {
      const ksySjkDt = {
        sjid: this.sjk.sjid,
        dtmc: txmc,
        tx: tx,
        mxtfz: 0,
        dtzf: 0,
        stgs: 0,
        stlx: '0',
        xxlx: '0',
        lxdf: '0',
        ksySjkStList: []
      }
      let maxDtid = 0 // 大题ID
      let maxXsxh = 0 // 显示序号
      if (!this.sjk.ksySjkDtList) {
        this.$set(this.sjk, 'ksySjkDtList', [])
      } else {
        maxDtid = this.sjk.ksySjkDtList.length > 0 ? Math.max.apply(null, this.sjk.ksySjkDtList.map(dt => Number(dt.dtid))) : 0
        maxXsxh = this.sjk.ksySjkDtList.length > 0 ? Math.max.apply(null, this.sjk.ksySjkDtList.map(dt => Number(dt.xsxh))) : 0
      }
      ksySjkDt.dtid = maxDtid + 1
      ksySjkDt.xsxh = maxXsxh + 1
      this.sjk.ksySjkDtList.push(ksySjkDt)
      this.$nextTick(() => {
        const maxDtid = this.sjk.ksySjkDtList.length - 1
        const currentSt = document.getElementById('dt' + maxDtid)
        currentSt.scrollIntoView(true) // 定位到指定位置
      })
    },
    // 选择试题
    addSt (ksySjkDt) {
      this.showDtList = true
      this.dtObj = ksySjkDt
      this.allDtData = this.sjk.ksySjkDtList
    },
    // 选择并关闭
    selectAndClose () {
      this.showDtList = false
    },
    // 设置抽提规则
    setCtgz (ksySjkDt) {
      this.showCtgz = true
      this.dtObj = ksySjkDt
      this.allDtData = this.sjk.ksySjkDtList
    },
    // 将标准答案 转换成 ABC
    parseABC (bzda, xxList) {
      if (!bzda) {
        return ''
      }
      return bzda.split('€').map(xxid => {
        const xx = xxList.find(xxObj => Number(xxObj.xxid) === Number(xxid))
        return xx ? this.options[xx.xsxh - 1] : ''
      }).join(',')
    },
    parseXxsm (bzda, xxList) {
      const xx = xxList.find(xxObj => Number(xxObj.xxid) === Number(bzda))
      return xx ? xx.xxsm : ''
    },
    // 初始化可见标志
    initVisFlag (DtObj, stObj) {
      // 如果是改变了单个试题分值
      if (stObj) {
        stObj.visibleFlag = true
        DtObj.visibleFlag = true
        this.countAll()
      } else {
        this.sjk.ksySjkDtList.forEach(ksySjkDt => {
          ksySjkDt.ksySjkStList.forEach(ksySjkSt => {
            if (ksySjkSt.stfz !== ksySjkDt.mxtfz) {
              ksySjkSt.visibleFlag = true
              ksySjkDt.visibleFlag = true
            }
          })
        })
      }
    },
    // 计算所有（包括：试卷总分、大题总分、题目个数、题目得分）
    countAll () {
      let sjzf = 0 // 试卷总分
      if (!this.sjk.ksySjkDtList) {
        return
      }
      if (this.sjk.zjfs !== '3') {
        this.sjk.ksySjkDtList.forEach(ksySjkDt => {
          let dtzf = 0 // 大题总分
          let stgs = 0 // 试题个数
          const mxtfz = ksySjkDt.mxtfz || 0
          ksySjkDt.ksySjkStList.forEach(ksySjkSt => {
            stgs++
            // 如果小题改变过，则不设置默认值
            if (!ksySjkSt.visibleFlag || !ksySjkSt.stfz) {
              ksySjkSt.stfz = mxtfz // 如果不是保存，则给小题赋默认值
            }
            dtzf += ksySjkSt.stfz
            // 组合题的小题分摊分数
            if (ksySjkSt.tx === '9') {
              let xtgs = 0 // 小题个数
              const xtNum = ksySjkSt.ksySjkZhtList.length
              const xtfz = xtNum === 0 ? mxtfz : Math.floor(mxtfz * 100 / xtNum) / 100
              ksySjkSt.ksySjkZhtList.forEach(ksySjkZh => {
                xtgs++
                ksySjkZh.xtfz = xtfz
              })
              ksySjkSt.stgs = xtgs
            }
          })

          ksySjkDt.dtzf = dtzf
          ksySjkDt.stgs = stgs
          sjzf += dtzf
        })
      } else {
        this.sjk.ksySjkDtList.forEach(ksySjkDt => {
          let dtzf = 0 // 大题总分
          let stgs = 0 // 试题个数
          const mxtfz = ksySjkDt.mxtfz || 0
          if (ksySjkDt.ksySjkCtgzList) {
            ksySjkDt.ksySjkCtgzList.forEach(ksySjkCtgz => {
              dtzf += (ksySjkCtgz.ctgs * mxtfz)
              stgs += ksySjkCtgz.ctgs
            })
          }
          ksySjkDt.dtzf = dtzf
          ksySjkDt.stgs = stgs
          sjzf += dtzf
        })
      }
      this.sjk.sjzf = sjzf
    },
    async submitForm () {
      this.countAll()
      if (!this.sjk.sjzf || this.sjk.sjzf === 0) {
        this.$message.warning('您还没有给试卷设置分数^-^')
        return false
      }

      const ksySjkDt = this.sjk.ksySjkDtList.find(ksySjkDt => !ksySjkDt.dtzf)
      if (ksySjkDt) {
        this.$message.warning(ksySjkDt.dtmc + '还没有设置分值^-^')
        return false
      }
      const params = this.sjk
      await save(params).then(res => {
        this.$http.callback(res, () => {
          this.$message.success(res.msg) // {"code":200,"msg":"试卷保存成功","data":2481076933120000}
          this.sjk.sjid = res.data
          // 生成快照
          setTimeout(() => {
            this.sjkStr = JSON.stringify(this.sjk)
          }, 200)
          const query = { sjid: this.sjk.sjid }
          if (this.ksid_init) {
            query.ksid = this.ksid_init
          }
          if (this.$route.path.endsWith('/exam/edit')) {
            this.$router.push({
              path: '/exam/edit',
              query: query
            })
          } else {
            this.$router.push({
              path: '/examPaper/edit',
              query: query
            })
          }
        })
      })
    },
    async submitFormAndBack () {
      const ok = await this.submitForm()
      if (ok === false) {
        return
      }
      if (this.ksid_init) {
        this.$router.push({
          path: '/exam/list'
        })
      } else {
        this.$router.push({
          path: '/examPaper/list'
        })
      }
    },
    initCtgz () {
      // 抽题组卷也保留分类
      if (this.sjk.zjfs === '3' || this.sjk.zjfs === '2') {
        this.sjk.ksySjkDtList.forEach(ksySjkDt => {
          if (ksySjkDt.ksySjkCtgzList.length > 0) {
            this.appendFlTag(ksySjkDt.dtid, ksySjkDt.ksySjkCtgzList[0]?.xzstfl)
          }
        })
      }
    },
    getSjkDetail (sjid) {
      const params = { sjid: sjid }
      detail(params).then(res => {
        this.$http.callback(res, () => {
          // 如果组卷方式发生了改变 则清空大题下面的试题、抽题规则
          if (this.sjk_init && this.sjk_init.zjfs !== res.data.zjfs) {
            res.data.ksySjkDtList.forEach(dtObj => {
              dtObj.ksySjkStList.splice(0)
              dtObj.ksySjkCtgzList.splice(0)
            })
          }
          this.sjk = Object.assign(res.data, this.sjk_init)
          this.initVisFlag() // 初始化可见标志
          this.countAll() // 调用方法 重新计算分数
          this.$nextTick(() => (
            this.initCtgz() // 页面加载完后，初始化抽屉规则
          ))
          // 生成快照
          setTimeout(() => {
            this.sjkStr = JSON.stringify(this.sjk)
            // 自动保存
            if (this.autoSave) {
              // 如果是新建试卷，判断是否有考试ID 有则添加到考试中
              if (this.ksid_init) {
                this.sjk.ksyKssj = { ksid: this.ksid_init }
              }
              this.submitForm()
            }
          }, 200)
        })
      })
    },
    switchTab (key, op) {
      if (op === 'init') {
        const tabs = this.$route.path.endsWith('/exam/edit') ? (this.constant.tabs) : (this.constant.tabs01)
        for (let i = 0; i < tabs.length; i++) {
          if (key === i) {
            this.constant.tabs[i].class01 = 'g-tab-clicked'
          } else {
            this.constant.tabs[i].class01 = 'g-tab-unclicked'
          }
        }
        return
      }

      this.toExamSetting()
    },
    toExamSetting () {
      if (this.sjkStr === '') {
        this.$message.warning('没有试卷内容')
        return
      }
      if (!this.sjk.sjzf || this.sjk.sjzf === 0) {
        this.$message.warning('您还没有给试卷设置分数^-^')
        return
      }
      if (this.sjkStr !== JSON.stringify(this.sjk)) {
        setTimeout(() => { // 此处必须要加延迟执行
          this.$confirm('是否放弃修改的内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.toExamSetting2()
          }).catch(() => {})
        }, 200)
      } else {
        this.toExamSetting2()
      }
    },
    toExamSetting2 () {
      const query = { sjid: this.sjk.sjid }
      if (this.ksid_init) {
        query.ksid = this.ksid_init
      }
      this.$router.push({
        path: '/exam/setting',
        query: query
      })
    },
    up (list, index) {
      if (index > 0) {
        const xsxh = index + 1 // 显示序号
        const index2 = index - 1 // index2为前一个问题
        list[index].xsxh = xsxh - 1
        list[index2].xsxh = xsxh
        list.splice(index2, 1, ...list.splice(index, 1, list[index2]))
      }
    },
    down (list, index) {
      if (index < list.length - 1) {
        const xsxh = index + 1 // 显示序号
        const index2 = index + 1 // index2为后一个问题
        list[index].xsxh = xsxh + 1
        list[index2].xsxh = xsxh
        list.splice(index2, 1, ...list.splice(index, 1, list[index2]))
      }
    },
    remove (list, index) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        list.splice(index, 1)
        // 重新排序
        for (let i = 0; i < list.length; i++) {
          list[i].xsxh = i + 1
        }
        // 计算总分
        this.countAll()
      }).catch(() => {})
    },
    showSet (stObj) {
      this.stObj = stObj
      this.showStEdit = true
    }
  },
  created () {
    this.ksid_init = this.$route.query.ksid
    this.sjid_init = this.$route.query.sjid
    const sjids = this.$route.query.sjids

    const sjmc = this.$route.query.sjmc
    const flbh = this.$route.query.flbh
    const zjfs = this.$route.query.zjfs

    // 自动保存
    this.autoSave = this.$route.query.autoSave

    if (this.sjid_init) {
      if (sjmc && flbh && zjfs) {
        this.sjk_init = { sjmc: sjmc, flbh: flbh, zjfs: zjfs }
      }
      this.getSjkDetail(this.sjid_init)
    } else if (sjids) {
      this.sjid_init = sjids.split(',')[0]
      this.getSjkDetail(this.sjid_init)
    } else if (sjmc && flbh && zjfs) {
      this.sjk = { sjmc: sjmc, flbh: flbh, zjfs: zjfs }
      // 如果是新建试卷，判断是否有考试ID 有则添加到考试中
      if (this.ksid_init) {
        this.sjk.ksyKssj = { ksid: this.ksid_init }
      }
    } else {
      this.$message.warning('请求地址不合法')
      return false
    }
  },
  mounted () {
    this.countAll()
    this.switchTab(0, 'init')
  }
}
</script>
<style lang="less" scoped>
  .dtTxContent {
    margin-top: 5px;
    width: 100%;
    text-align: center;
    padding-bottom: 5px;
    border-bottom: 1px solid #e6e6e6;
  }
  .dtTxBtn {
    margin: 3px 2px;
    width: 100px;
    border: 1px solid #d8d8d8;
    border-radius: 3px;
    color: #707070;
    padding: 6px;
    background-color: #ffffff;
    display: inline-block;
  }
  .dtTxBtn:hover {
    cursor: pointer;
    border: 1px solid #409EFF;
    background-color: #f0ffff;
  }
  .customIcon {
    height: 16px;
    width: 16px;
    vertical-align: text-top;
    margin-right: 3px;
  }

  .dtDiv {
    margin-bottom: 20px;
    position: relative;
    padding: 0px 10px;
    border: 1px solid #0094ff;
    background-color: #fafafa;
  }
  .stDiv {
    background-color: #ffffff;
    position: relative;
    margin: 10px 0px;
    padding: 5px 10px;
  }
  .dtHandle {
    position: absolute;
    right: 25px;
    top: 5px;
    z-index: 999;
  }
  .stDiv:hover .stHandle {
    display: flex;
  }
  .stHandle {
    display: none;
    position: absolute;
    right: 25px;
    top: 20px;
    z-index: 999;
  }
  .handle span {
    margin: 0 10px;
    font-size: 20px;
    color: #409EFF;
  }
  .handle span:hover {
    cursor: pointer;
  }
</style>
